import dayjs from "dayjs";


export function ReadableDateTime(date){
    return dayjs(date).format('ddd, MMM D, YYYY / h:mm A')
}
export function ReadableDate(date){
    return dayjs(date).format('ddd, MMM D, YYYY')
}